/** Shared same-page history for storefront overlays. */
(function () {
  "use strict";
  var key = "avyuOverlay";
  var views = {};
  var active = null;
  var pending = false;
  var afterClose = null;
  var previousOverflow = "";

  function show(name) {
    if (active === name) return;
    if (active) views[active](false);
    if (!active && name) {
      previousOverflow = document.body.style.overflow;
      document.body.style.overflow = "hidden";
    }
    active = name;
    if (name) views[name](true);
    else document.body.style.overflow = previousOverflow;
  }

  window.AVYU.overlays = {
    register: function (name, render) { views[name] = render; },
    open: function (name) {
      if (pending || active === name) return;
      var state = Object.assign({}, history.state);
      state[key] = name;
      if (active) history.replaceState(state, "", location.href);
      else history.pushState(state, "", location.href);
      show(name);
    },
    close: function (name, callback) {
      if (active !== name || pending) return;
      if (history.state && history.state[key] === name) {
        pending = true;
        afterClose = callback || null;
        history.back();
      } else {
        show(null);
        if (callback) callback();
      }
    }
  };
  window.addEventListener("popstate", function () {
    var name = history.state && history.state[key];
    show(views[name] ? name : null);
    pending = false;
    var callback = afterClose;
    afterClose = null;
    if (callback) callback();
  });
  window.addEventListener("pageshow", function () {
    pending = false;
    afterClose = null;
    var name = history.state && history.state[key];
    show(views[name] ? name : null);
  });
})();
